<script setup lang="ts">
    defineProps<{
        icon: string;
    }>();
</script>

<template>
    <div class="teaser-icon">
        <Icon
            class="teaser-icon-svg"
            :name="icon"
            mode="svg"
            size="22px"
        />
    </div>
</template>

<style scoped lang="scss">
    .teaser-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        background-color: $white;
        border-radius: $border-radius-circle;
        color: $brand-primary;

        :deep(.teaser-icon-svg),
        :deep(.teaser-icon-svg *) {
            stroke-width: 2;
        }
    }
</style>
